export enum SortOrder {
    DESC = 'DESC',
    ASC = 'ASC'
}
